import { Component,Input, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-consulta-cliente',
  templateUrl: './modal-consulta-cliente.component.html',
  styleUrls: ['./modal-consulta-cliente.component.scss']
})
export class ModalConsultaClienteComponent implements OnInit {
  codigoConsulta = 3
  mensajeConsulta = 'Ingrese el numero de DPI del cliente'
  alertaValidacion=''
  parametroConsulta=''
  alertError = false
  beginDate = moment(new Date()).format('YYYY-MM-DD');
  endDate = moment(new Date()).format('YYYY-MM-DD');
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  beginLimitDate ='2021-09-01'
  constructor(public dialogRef: MatDialogRef<ModalConsultaClienteComponent>) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  realizarConsulta() {
    if (this.parametroConsulta=='') {
      this.alertaValidacion='*Ingrese el valor solicitado*'
      this.alertError = true
      setTimeout(() => {
        this.alertError= false
      }, 5000);
    }
    else if (((this.codigoConsulta == 2 || this.codigoConsulta == 3) && (this.parametroConsulta.toString().length < 13 || this.parametroConsulta.toString().length > 13))) {
      this.alertaValidacion='*Ingres un numero de DPI valido*'
      this.alertError = true
      setTimeout(() => {
        this.alertError= false
      }, 5000);
    } else {
      if (this.codigoConsulta == 1 || this.codigoConsulta == 3) {
        this.dialogRef.close({
          codigoConsulta: this.codigoConsulta,
          parametroConsulta: this.parametroConsulta
        }) 
      } else {
        this.dialogRef.close({
          codigoConsulta: this.codigoConsulta,
          parametroConsulta: this.parametroConsulta,
          fechaInicio: moment(this.beginDate).format("DD/MM/YYYY"),
          fechaFin: moment(this.endDate).format("DD/MM/YYYY")
        })
      }
    }
  }
  changeMessage() {
    this.mensajeConsulta = this.codigoConsulta == 1 ? 'Ingrese el numero de precalificación' : 'Ingrese el numero de DPI del cliente';
  }
}
